import { IAppState } from '../../../common/state';

export const getisCommercialSaveSearchModalOpened = (state: IAppState): boolean =>
  state.isCommercialSaveSearchModalOpened;
